import Header from '../Layout/Header';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { spocLocationDetails, dataUser } from '../Helpers/util';
import axiosInstance from '../../utils/axiosInstance';
import moment from 'moment';
import axios from 'axios';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import SwRadio from '../Common/FormComponent/SwRadio';
import SwInput from '../Common/FormComponent/SwInput';
import SwOffCanvas from '../Common/SwOffCanvas/SwOffCanvas';
import SwButton from '../Common/SwButtons/SwButtons';
import AntDDatePicker from '../Common/AntDDateTimePicker/AntDDatePicker';
import dayjs from 'dayjs';
import SwModal from '../Common/SwModal/SwModal';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);
const userDataLocal12 = spocLocationDetails();

const timeData = [
  {
    label: '12:00 AM',
    value: '00:00',
    isdisabled: false,
  },
  {
    label: '12:30 AM',
    value: '00:30',
    isdisabled: false,
  },
  {
    label: '01:00 AM',
    value: '01:00',
    isdisabled: false,
  },
  {
    label: '01:30 AM',
    value: '01:30',
    isdisabled: false,
  },
  {
    label: '02:00 AM',
    value: '02:00',
    isdisabled: false,
  },
  {
    label: '02:30 AM',
    value: '02:30',
    isdisabled: false,
  },
  {
    label: '03:00 AM',
    value: '03:00',
    isdisabled: false,
  },
  {
    label: '03:30 AM',
    value: '03:30',
    isdisabled: false,
  },
  {
    label: '04:00 AM',
    value: '04:00',
    isdisabled: false,
  },
  {
    label: '04:30 AM',
    value: '04:30',
    isdisabled: false,
  },
  {
    label: '05:00 AM',
    value: '05:00',
    isdisabled: false,
  },
  {
    label: '05:30 AM',
    value: '05:30',
    isdisabled: false,
  },
  {
    label: '06:00 AM',
    value: '06:00',
    isdisabled: false,
  },
  {
    label: '06:30 AM',
    value: '06:30',
    isdisabled: false,
  },
  {
    label: '07:00 AM',
    value: '07:00',
    isdisabled: false,
  },
  {
    label: '07:30 AM',
    value: '07:30',
    isdisabled: false,
  },
  {
    label: '08:00 AM',
    value: '08:00',
    isdisabled: false,
  },
  {
    label: '08:30 AM',
    value: '08:30',
    isdisabled: false,
  },
  {
    label: '09:00 AM',
    value: '09:00',
    isdisabled: false,
  },
  {
    label: '09:30 AM',
    value: '09:30',
    isdisabled: false,
  },
  {
    label: '10:00 AM',
    value: '10:00',
    isdisabled: false,
  },
  {
    label: '10:30 AM',
    value: '10:30',
    isdisabled: false,
  },
  {
    label: '11:00 AM',
    value: '11:00',
    isdisabled: false,
  },
  {
    label: '11:30 AM',
    value: '11:30',
    isdisabled: false,
  },
  {
    label: '12:00 PM',
    value: '12:00',
    isdisabled: false,
  },
  {
    label: '12:30 PM',
    value: '12:30',
    isdisabled: false,
  },
  {
    label: '01:00 PM',
    value: '13:00',
    isdisabled: false,
  },
  {
    label: '01:30 PM',
    value: '13:30',
    isdisabled: false,
  },
  {
    label: '02:00 PM',
    value: '14:00',
    isdisabled: false,
  },
  {
    label: '02:30 PM',
    value: '14:30',
    isdisabled: false,
  },
  {
    label: '03:00 PM',
    value: '15:00',
    isdisabled: false,
  },
  {
    label: '03:30 PM',
    value: '15:30',
    isdisabled: false,
  },
  {
    label: '04:00 PM',
    value: '16:00',
    isdisabled: false,
  },
  {
    label: '04:30 PM',
    value: '16:30',
    isdisabled: false,
  },
  {
    label: '05:00 PM',
    value: '17:00',
    isdisabled: false,
  },
  {
    label: '05:30 PM',
    value: '17:30',
    isdisabled: false,
  },
  {
    label: '06:00 PM',
    value: '18:00',
    isdisabled: false,
  },
  {
    label: '06:30 PM',
    value: '18:30',
    isdisabled: false,
  },
  {
    label: '07:00 PM',
    value: '19:00',
    isdisabled: false,
  },
  {
    label: '07:30 PM',
    value: '19:30',
    isdisabled: false,
  },
  {
    label: '08:00 PM',
    value: '20:00',
    isdisabled: false,
  },
  {
    label: '08:30 PM',
    value: '20:30',
    isdisabled: false,
  },
  {
    label: '09:00 PM',
    value: '21:00',
    isdisabled: false,
  },
  {
    label: '09:30 PM',
    value: '21:30',
    isdisabled: false,
  },
  {
    label: '10:00 PM',
    value: '22:00',
    isdisabled: false,
  },
  {
    label: '10:30 PM',
    value: '22:30',
    isdisabled: false,
  },
  {
    label: '11:00 PM',
    value: '23:00',
    isdisabled: false,
  },
  {
    label: '11:30 PM',
    value: '23:30',
    isdisabled: false,
  },
];

const etimeData = [
  {
    label: '12:00 AM',
    value: '00:00',
    isdisabled: false,
  },
  {
    label: '12:30 AM',
    value: '00:30',
    isdisabled: false,
  },
  {
    label: '01:00 AM',
    value: '01:00',
    isdisabled: false,
  },
  {
    label: '01:30 AM',
    value: '01:30',
    isdisabled: false,
  },
  {
    label: '02:00 AM',
    value: '02:00',
    isdisabled: false,
  },
  {
    label: '02:30 AM',
    value: '02:30',
    isdisabled: false,
  },
  {
    label: '03:00 AM',
    value: '03:00',
    isdisabled: false,
  },
  {
    label: '03:30 AM',
    value: '03:30',
    isdisabled: false,
  },
  {
    label: '04:00 AM',
    value: '04:00',
    isdisabled: false,
  },
  {
    label: '04:30 AM',
    value: '04:30',
    isdisabled: false,
  },
  {
    label: '05:00 AM',
    value: '05:00',
    isdisabled: false,
  },
  {
    label: '05:30 AM',
    value: '05:30',
    isdisabled: false,
  },
  {
    label: '06:00 AM',
    value: '06:00',
    isdisabled: false,
  },
  {
    label: '06:30 AM',
    value: '06:30',
    isdisabled: false,
  },
  {
    label: '07:00 AM',
    value: '07:00',
    isdisabled: false,
  },
  {
    label: '07:30 AM',
    value: '07:30',
    isdisabled: false,
  },
  {
    label: '08:00 AM',
    value: '08:00',
    isdisabled: false,
  },
  {
    label: '08:30 AM',
    value: '08:30',
    isdisabled: false,
  },
  {
    label: '09:00 AM',
    value: '09:00',
    isdisabled: false,
  },
  {
    label: '09:30 AM',
    value: '09:30',
    isdisabled: false,
  },
  {
    label: '10:00 AM',
    value: '10:00',
    isdisabled: false,
  },
  {
    label: '10:30 AM',
    value: '10:30',
    isdisabled: false,
  },
  {
    label: '11:00 AM',
    value: '11:00',
    isdisabled: false,
  },
  {
    label: '11:30 AM',
    value: '11:30',
    isdisabled: false,
  },
  {
    label: '12:00 PM',
    value: '12:00',
    isdisabled: false,
  },
  {
    label: '12:30 PM',
    value: '12:30',
    isdisabled: false,
  },
  {
    label: '01:00 PM',
    value: '13:00',
    isdisabled: false,
  },
  {
    label: '01:30 PM',
    value: '13:30',
    isdisabled: false,
  },
  {
    label: '02:00 PM',
    value: '14:00',
    isdisabled: false,
  },
  {
    label: '02:30 PM',
    value: '14:30',
    isdisabled: false,
  },
  {
    label: '03:00 PM',
    value: '15:00',
    isdisabled: false,
  },
  {
    label: '03:30 PM',
    value: '15:30',
    isdisabled: false,
  },
  {
    label: '04:00 PM',
    value: '16:00',
    isdisabled: false,
  },
  {
    label: '04:30 PM',
    value: '16:30',
    isdisabled: false,
  },
  {
    label: '05:00 PM',
    value: '17:00',
    isdisabled: false,
  },
  {
    label: '05:30 PM',
    value: '17:30',
    isdisabled: false,
  },
  {
    label: '06:00 PM',
    value: '18:00',
    isdisabled: false,
  },
  {
    label: '06:30 PM',
    value: '18:30',
    isdisabled: false,
  },
  {
    label: '07:00 PM',
    value: '19:00',
    isdisabled: false,
  },
  {
    label: '07:30 PM',
    value: '19:30',
    isdisabled: false,
  },
  {
    label: '08:00 PM',
    value: '20:00',
    isdisabled: false,
  },
  {
    label: '08:30 PM',
    value: '20:30',
    isdisabled: false,
  },
  {
    label: '09:00 PM',
    value: '21:00',
    isdisabled: false,
  },
  {
    label: '09:30 PM',
    value: '21:30',
    isdisabled: false,
  },
  {
    label: '10:00 PM',
    value: '22:00',
    isdisabled: false,
  },
  {
    label: '10:30 PM',
    value: '22:30',
    isdisabled: false,
  },
  {
    label: '11:00 PM',
    value: '23:00',
    isdisabled: false,
  },
  {
    label: '11:30 PM',
    value: '23:30',
    isdisabled: false,
  },
];

function CreateRoomBooking({ show, onClose, refreshList, refreshCreditHours }) {
  const [locationSpoc, setLocationSpoc] = useState([]); // Stores location data
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [locationData, setLocationData] = useState([]);
  const [tt, setTT] = useState(timeData);
  const [etData, setEtData] = useState(etimeData);
  const [location, setLocation] = useState({});
  const [meetingRoom, setMeetingRoom] = useState('');
  const [meetingData, setMeetingData] = useState([]);

  const [startDate, setStartDate] = useState('');
  const [sD, setSD] = useState('');
  const [eT, setET] = useState('');
  const [endDate, setEndDate] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [bookingValidate, setBookingValidate] = useState([]);
  const [dayData, setDayData] = useState('exclude');
  const [disabledData, setDisabledData] = useState(true);
  const [meetingType, setMeetingType] = useState('');
  const [timeSlot, setTimeSlot] = useState('');
  const [pricePerSlot, setPricePerSlot] = useState('');
  const [isContainsWeekend, setIsContainsWeekend] = useState(false);
  const [totalChargeableAmount, setTotalChargeableAmount] = useState('');
  const [showConfirmBooking, setShowConfirmBooking] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [meetingRoomLoading, setMeetingRoomLoading] = useState(false);

  const fetchLocationData = async () => {
    try {
      const { data } = await axiosInstance.get(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v2/basic-data/get-location-by-spoc`,
        {
          params: { spoc: UserObj.rec_id, client: UserObj?.company_id },
        },
      );

      if (
        data?.status === 'success' &&
        Array.isArray(data.data) &&
        data.data.length > 0
      ) {
        setLocationSpoc(data.data);
      } else {
        console.warn('No locations found.');
        setLocationSpoc([]);
      }
    } catch (error) {
      console.error('Error fetching location data:', error);
    }
  };

  // Fetch data on mount
  useEffect(() => {
    fetchLocationData();
  }, []);

  // Everything downstream of the location: the availability API is keyed on
  // propertyId + start/end, so a location change invalidates all of it.
  const resetBookingFields = () => {
    setStartDate('');
    setEndDate('');
    setStartTime('');
    setEndTime('');
    setSD('');
    setET('');
    setMeetingData([]);
    setMeetingRoom('');
    setMeetingType('');
    setTimeSlot('');
    setPricePerSlot('');
    setBookingValidate([]);
    setTotalChargeableAmount('');
    setDayData('exclude');
    setIsContainsWeekend(false);
    setDisabledData(true);
  };

  // Handle dropdown selection
  const handleLocationChange = selectedOption => {
    setSelectedLocation(selectedOption.value);
    resetBookingFields();
  };

  useEffect(() => {
    var LocationSpoc = JSON.parse(userDataLocal12);
    setLocationData(LocationSpoc);
  }, []);

  const handleCloseBooking = () => {
    if (isSubmitting) return;
    setShowConfirmBooking(false);
  };
  const handleOpenBookingModal = () => {
    setShowConfirmBooking(true);
  };

  const getMeetingRoomList = async () => {
    const organizationData = JSON.parse(localStorage.getItem('headData'));
    setMeetingRoomLoading(true);
    try {
      let authToken = JSON.parse(localStorage.getItem('headData'));
      const newCompanyId = JSON.parse(localStorage.getItem('headData'));
      // Combine start and end times with their respective dates
      const startDateTime = moment
        .tz(`${startDate} ${startTime}`, 'YYYY-MM-DD HH:mm', 'Asia/Kolkata')
        .utc() // Convert to UTC
        .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'); // ISO 8601 format

      const endDateTime = moment
        .tz(`${endDate} ${endTime}`, 'YYYY-MM-DD HH:mm', 'Asia/Kolkata')
        .utc() // Convert to UTC
        .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'); // ISO 8601 format

      // Prepare the API request payload
      const params = {
        clientId: newCompanyId.organizationId,
        start: startDateTime,
        propertyId: selectedLocation,
        end: endDateTime,

        type: ['Meeting Room', 'Conference Room', 'Training Room', 'AV Lounge'],
      };

      // Await the response from the API request
      const res = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }meeting-room/api/resource/available`,
        params,
        {
          headers: {
            'req-organization-id': organizationData.organizationId,
          },
        },
      );

      // Check if the response status is 200
      if (res.data.status === 200) {
        // Map the response data to populate your dropdown options
        const list = res.data.data.list.map(room => ({
          label: room.name,
          value: room._id, // Set value to _id instead of name
          id: room._id,
          meetingTypeData: room.type,
          timeSlot: room.timeSlot,
          pricePerSlot: room.pricePerSlot,
        }));

        // Update state with meeting rooms data
        setMeetingData(list);
      } else {
        // Handle failure response
        // toast.configure();
        toast.error(res.data.message, {
          //
        });
        setMeetingData([]);
      }
    } catch (error) {
      // Catch any errors from the API request
      console.error('API call failed:', error);
      // Surface the actual backend message (e.g. "No Meeting Room ... is
      // available for this duration") when the API responds with an error
      // status; fall back to a generic message otherwise.
      toast.error(
        error?.response?.data?.message ||
          'Failed to fetch meeting rooms. Please try again.',
      );
      setMeetingData([]);
    } finally {
      setMeetingRoomLoading(false);
    }
  };
  useEffect(() => {
    if (
      startDate &&
      endDate &&
      startTime &&
      endTime &&
      location &&
      meetingRoom &&
      dayData
    ) {
      // The room list is already fetched by the endTime-driven effect below.
      // Re-fetching here (this block only runs once a room is selected) would
      // needlessly re-show the "loading" state after data is already loaded.
      validateMRBookingAPI();
      setDisabledData(false);
    }
    if (startTime > endTime) {
      setDisabledData(true);
    }

    if (moment().format('YYYY-MM-DD') == startDate) {
      let d = [...tt];
      for (let i = 0; i < d.length; i++) {
        if (d[i].value < moment().format('HH:mm')) {
          d[i].isdisabled = true;
        }
      }
      setTT(d);
    } else {
      let d = [...tt];
      for (let i = 0; i < d.length; i++) {
        if (d[i].value < moment().format('HH:mm')) {
          d[i].isdisabled = false;
        }
      }
      setTT(d);
    }

    if (endDate == moment().format('YYYY-MM-DD')) {
      let d = [...etData];

      for (let i = 0; i < d.length; i++) {
        if (
          d[i].value >=
          moment()
            .add(30, 'minutes')
            .format('HH:mm')
        ) {
          d[i].isdisabled = false;
        } else {
          d[i].isdisabled = true;
        }
      }
      setEtData(d);
    } else {
      let d = [...etData];
      for (let i = 0; i < d.length; i++) {
        d[i].isdisabled = false;
      }
      setEtData(d);
    }

    var CurrentDate = moment().unix();

    const isContainingWeekend = containsWeekend(startDate, endDate);
    setIsContainsWeekend(isContainingWeekend);

    if (!isContainingWeekend) {
      setDayData('exclude');
    }
  }, [startDate, endDate, startTime, endTime, location, meetingRoom, dayData]);

  useEffect(() => {
    if (endTime.length > 0) getMeetingRoomList();
  }, [endTime, location, startDate, endDate, startTime]);

  const changeSelect = selected => {
    setLocation(selected);
    setBookingValidate('');
    setMeetingData('');
    setMeetingRoom('');
  };

  const handelChangeVal = e => {
    setDayData(e.target.value);
  };

  function calculateMultiDayBookingChargesWithWeekends(
    startDate,
    endDate,
    startTime,
    endTime,
    slotDuration,
    pricePerSlot,
    weekendOption, // Default to "include" weekends
  ) {
    // Parse the input dates
    const start = new Date(startDate);
    const end = new Date(endDate);

    // Helper function to determine if a date is a weekend
    function isWeekend(date) {
      const day = date.getDay(); // 0 = Sunday, 6 = Saturday
      return day === 0 || day === 6;
    }

    // Calculate total days (inclusive of start and end dates)
    let currentDate = new Date(start);
    let totalDays = 0;

    while (currentDate <= end) {
      const isSunday = currentDate.getDay() === 0;
      const isSaturday = currentDate.getDay() === 6;

      if (
        weekendOption === 'include' || // Include all days
        (weekendOption === 'exclude' && !isWeekend(currentDate)) || // Exclude Saturdays and Sundays
        (weekendOption === 'excludeSundays' && !isSunday) // Exclude Sundays only
      ) {
        totalDays++;
      }

      // Move to the next day
      currentDate.setDate(currentDate.getDate() + 1);
    }

    // Calculate the duration of the booking per day in hours
    const startHour = parseInt(startTime.split(':')[0]);
    const endHour = parseInt(endTime.split(':')[0]);
    const bookingHoursPerDay = endHour - startHour;

    // Calculate the number of slots per day
    const slotsPerDay = (bookingHoursPerDay * 60) / slotDuration;

    // Calculate total slots for the booking
    const totalSlots = totalDays * slotsPerDay;

    // Calculate the total charges
    const totalCharges = totalSlots * pricePerSlot;
    setTotalChargeableAmount(totalCharges);

    return totalCharges;
  }

  const changeMeetingRoomSelecet = e => {
    let selectedMeetingRoom = {};
    meetingData.map(ev => {
      if (ev.id == e.target.value) {
        selectedMeetingRoom = ev;
        setMeetingType(ev.meetingTypeData);
        setTimeSlot(ev.timeSlot);
        setPricePerSlot(ev.pricePerSlot);
      }
    });
    setMeetingRoom(e.target.value);
    if (e.target.value == '') {
      setBookingValidate([]);
    }

    const charges = calculateMultiDayBookingChargesWithWeekends(
      startDate,
      endDate,
      startTime,
      endTime,
      selectedMeetingRoom.timeSlot,
      selectedMeetingRoom.pricePerSlot,
      dayData,
    );
  };

  useEffect(() => {
    if (meetingRoom) validateMRBookingAPI();
  }, [meetingRoom]);

  const validateMRBookingAPI = async => {
    let authToken = JSON.parse(localStorage.getItem('headData'));
    const params = {
      company_id: UserObj ? UserObj.company_id : null,
      location_id: location.value,
      meetingroom_id: meetingRoom,
      startTime: startTime,
      endTime: endTime,
      startDate: startDate,
      endDate: endDate,
      booking_type: dayData,
      mr_type: meetingType,
    };
    axios
      .post(
        `${process.env.REACT_APP_API_URL}user/validate-mr-booking`,
        params,
        {
          headers: {
            Authorization: authToken?.spintlyToken,
          },
        },
      )
      .then(response => {
        setBookingValidate(
          response.data.totalAmount == null ? '' : response.data.totalAmount,
        );
      });
  };

  const onFormSubmit = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      let authToken = JSON.parse(localStorage.getItem('headData'));

      if (!authToken) {
        console.error('No authentication data found.');
        toast.error('Authentication failed. Please log in again.');
        return;
      }

      // Combine startDate with startTime and endDate with endTime in IST
      const startDateTime = moment
        .tz(`${startDate} ${startTime}`, 'YYYY-MM-DD HH:mm', 'Asia/Kolkata')
        .utc() // Convert to UTC
        .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'); // ISO 8601 format

      const endDateTime = moment
        .tz(`${endDate} ${endTime}`, 'YYYY-MM-DD HH:mm', 'Asia/Kolkata')
        .utc() // Convert to UTC
        .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'); // ISO 8601 format

      const duration = moment.duration(
        moment(endDateTime).diff(moment(startDateTime)),
      );
      const hoursDifference = duration.asHours();

      let hostId = authToken.coreUser?.id;

      if (!hostId) {
        console.error('Host ID not found in local storage.');
        toast.error('User information is missing. Please log in again.');
        return;
      }

      const params = {
        resourceId: meetingRoom,
        bookedFrom: 'Cspoc',
        hostId: hostId,
        start: startDateTime, // UTC start time
        end: endDateTime, // UTC end time
        weekendOption: dayData,
        resourceType: meetingType,
        totalCharges: totalChargeableAmount,
      };

      if (hoursDifference > 24) {
        params.isMultiDay = true;
      }

      const organizationData = JSON.parse(localStorage.getItem('headData'));

      if (
        !organizationData ||
        !organizationData.organizationId ||
        !organizationData.roomShared
      ) {
        console.error('Organization data is missing.');
        toast.error(
          'Organization information is missing. Please log in again.',
        );
        return;
      }

      const response = await axiosInstance.post(
        `${
          process.env.REACT_APP_API_GATEWAYS_URL
        }meeting-room/api/booking/resource`,
        params,
        {
          headers: {
            'req-organization-id': organizationData.organizationId,
            'req-organization-type': organizationData.roomShared,
          },
        },
      );

      if (response.data.status === 200) {
        toast.success(response.data.message);
        setShowConfirmBooking(false);

        // Close drawer and refresh bookings list + credit hours without a full page reload
        if (typeof onClose === 'function') onClose();
        if (typeof refreshList === 'function') refreshList();
        if (typeof refreshCreditHours === 'function') refreshCreditHours();
      } else {
        // Keep the confirmation modal open so the user can retry.
        toast.error(response.data.message || 'Booking failed.');
      }
    } catch (error) {
      console.error('Booking failed:', error);
      toast.error('Failed to book the meeting. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const onStartDateChange = e => {
    // setSD('')
    // setStartTime('')
    // setET('')
    // setEndDate('')
    setStartDate(e.target.value);
  };

  const onEndDateChange = e => {
    setEndDate(e.target.value);
  };

  const onStartTimeChange = selected => {
    setSD(selected);
    setStartTime(selected.value);
  };

  const onEndTimeChange = selected => {
    setET(selected);
    setEndTime(selected.value);
    setBookingValidate('');
  };

  const resetValue = () => {
    setLocation({});
    setSelectedLocation(null);
    resetBookingFields();
  };

  const containsWeekend = (startDate, endDate) => {
    let currentDate = new Date(startDate);
    const endDateObj = new Date(endDate);

    while (currentDate <= endDateObj) {
      if (currentDate.getDay() === 0 || currentDate.getDay() === 6) {
        return true;
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return false;
  };
  const locationOptions = locationSpoc.map(loc => ({
    value: loc.newId,
    label: loc.location_name,
  }));

  const meetingRoomOptions =
    meetingData.length > 0
      ? meetingData.map(item => ({
          value: item.value,
          label: `${item.label} (${item.meetingTypeData})`,
        }))
      : [];

  return (
    <>
      {/* <Header /> */}
      {/* CreateRoomBooking Form */}
      <SwOffCanvas
        show={show}
        onClose={onClose}
        id="myModal1"
        title="Create Room Booking"
        footer={
          <>
            <div className="OffCanvasFooter_Btns">
              <SwButton
                size="md"
                variant="dark-outline"
                type="button"
                onClick={resetValue}
              >
                Reset
              </SwButton>

              {disabledData == true ? (
                <SwButton
                  size="md"
                  onClick={handleOpenBookingModal}
                  type="button"
                  disabled
                >
                  Submit Room Booking
                </SwButton>
              ) : (
                <SwButton
                  size="md"
                  onClick={handleOpenBookingModal}
                  type="button"
                >
                  Submit Room Booking
                </SwButton>
              )}
            </div>
          </>
        }
      >
        <form>
          <div class="card-body">
            <div>
              <div className="row">
                <div className="col-md-12 col-xl-12 col-lg-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">
                      Location<span className="Required">*</span>
                    </label>
                    <SwSelect
                      id="CRBLocation"
                      name="location"
                      options={locationOptions}
                      value={
                        locationOptions.find(
                          option => option.value === selectedLocation,
                        ) || null
                      }
                      onChange={handleLocationChange}
                      placeholder="Select Location"
                      isClearable={false}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-xl-12 col-lg-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">
                      Start Date<span className="Required">*</span>
                    </label>
                    <AntDDatePicker
                      type="single"
                      name="startDate"
                      format="DD/MM/YYYY"
                      value={startDate ? dayjs(startDate, 'YYYY-MM-DD') : null}
                      disabled={meetingRoomLoading}
                      disabledDate={current =>
                        current && current < dayjs().startOf('day')
                      }
                      onChange={date => {
                        const formattedDate = date
                          ? date.format('YYYY-MM-DD')
                          : '';
                        setStartDate(formattedDate);

                        // reset dependent fields
                        setEndDate('');
                        setStartTime('');
                        setEndTime('');
                        setSD('');
                        setET('');
                      }}
                      allowClear={false}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-xl-12 col-lg-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">
                      End Date<span className="Required">*</span>
                    </label>
                    <AntDDatePicker
                      type="single"
                      name="endDate"
                      format="DD/MM/YYYY"
                      value={endDate ? dayjs(endDate, 'YYYY-MM-DD') : null}
                      disabled={!startDate || meetingRoomLoading}
                      disabledDate={current =>
                        startDate
                          ? current && current < dayjs(startDate, 'YYYY-MM-DD')
                          : true
                      }
                      onChange={date => {
                        const formattedDate = date
                          ? date.format('YYYY-MM-DD')
                          : '';
                        setEndDate(formattedDate);
                      }}
                      allowClear={false}
                    />
                  </div>
                </div>
              </div>

              {isContainsWeekend && (
                <div className="col-md-12 col-xl-12 col-lg-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">Select Days</label>
                    <div className="d-flex gap-2" onChange={handelChangeVal}>
                      <SwRadio
                        id="include"
                        name="dayData"
                        value="include"
                        label="Including weekends"
                        checked={dayData === 'include'}
                      />
                      <SwRadio
                        id="excludeSundays"
                        name="dayData"
                        value="excludeSundays"
                        label="Excluding only Sunday"
                        checked={dayData === 'excludeSundays'}
                      />
                      <SwRadio
                        id="exclude"
                        name="dayData"
                        value="exclude"
                        label="Excluding weekends"
                        checked={dayData === 'exclude'}
                      />
                    </div>
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col-md-12 col-xl-12 col-lg-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">
                      Start Time<span className="Required">*</span>
                    </label>
                    <SwSelect
                      id="CRBStartTime"
                      options={tt}
                      name="startTime"
                      onChange={onStartTimeChange}
                      value={sD}
                      placeholder="Select Start time"
                      isOptionDisabled={option => option.isdisabled}
                      isDisabled={meetingRoomLoading}
                      isClearable={false}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-xl-12 col-lg-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">
                      End Time<span className="Required">*</span>
                    </label>
                    <SwSelect
                      id="CRBEndTime"
                      placeholder="Select End time"
                      name="endTime"
                      onChange={onEndTimeChange}
                      value={eT}
                      isOptionDisabled={option => option.isdisabled}
                      isDisabled={meetingRoomLoading}
                      options={etimeData}
                      isClearable={false}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-xl-12 col-lg-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">
                      Meeting Room<span className="Required">*</span>
                    </label>
                    <SwSelect
                      options={meetingRoomOptions}
                      placeholder={
                        meetingRoomLoading
                          ? 'Available meeting room is loading...'
                          : meetingData.length > 0
                          ? 'Select meeting room'
                          : 'No meeting room available'
                      }
                      isLoading={meetingRoomLoading}
                      isClearable={false}
                      value={
                        meetingRoomOptions.find(
                          option => option.value === meetingRoom,
                        ) || null
                      }
                      onChange={selectedOption => {
                        changeMeetingRoomSelecet({
                          target: {
                            name: 'meetingRoom',
                            value: selectedOption ? selectedOption.value : '',
                          },
                        });
                      }}
                      isDisabled={meetingRoomLoading || meetingData.length === 0}
                    />
                  </div>
                  {meetingRoomLoading ? (
                    <span style={{ color: '#0b8aff', fontSize: '12px' }}>
                      Available meeting room is loading...
                    </span>
                  ) : (
                    meetingData.length === 0 && (
                      <span style={{ color: 'red', fontSize: '12px' }}>
                        No meeting room available *
                      </span>
                    )
                  )}
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 col-xl-12 col-lg-12">
                  <div className="SwFormGroup">
                    <label className="SwFormLabel">
                      Total Chargeable Amount<span className="Required">*</span>
                    </label>
                    <SwInput
                      id="RCBChargeableAmount"
                      placeholder="Enter Total Chargeable Amount"
                      type="text"
                      name="chargeableAmount"
                      value={totalChargeableAmount}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </SwOffCanvas>
      {/* ConfirmationPopup */}
      {/* <div
       className=" modal fade qrModel  "
       id="roomBooking" data-backdrop="static"
     >
       <div className="modal-dialog ">
         <div className="modal-content ">
           <div className="formTitle">
             <p>Alert !! </p>
             <button
               type="button"
               className="relateDox close"
               data-dismiss="modal"
             >
               x
             </button>
           </div>
           <div className="modal-body">
             <div className="qrScannerMain">
               <div className="row">
                 <div className="col-md-12 ">
                   <p id="modalText">
                     Are you sure you want to confirm the room booking?
                   </p>
                 </div>
               </div>
             </div>
           </div>
           <div class="modal-footer">
             <button className="btn btn" data-dismiss="modal"
             // onClick={cancelEvent}
             >
               Cancel
             </button>
             <button
               className="btn btn-success"
               data-dismiss="modal"
               onClick={onFormSubmit}
             >Confirm
             </button>
           </div>
         </div>
       </div>
     </div> */}

      {/* ConfirmationPopup using SwModal */}
      <SwModal
        show={showConfirmBooking}
        onClose={handleCloseBooking}
        className="sw-small-modal"
        centered
        backdrop="static"
        keyboard={false}
        footer={
          <div className="d-flex justify-content-center align-items-center gap-3">
            <SwButton
              variant="dark-outline"
              size="sm"
              onClick={handleCloseBooking}
              disabled={isSubmitting}
            >
              Cancel
            </SwButton>

            <SwButton
              variant="primary"
              size="sm"
              onClick={onFormSubmit}
              loading={isSubmitting}
            >
              Confirm
            </SwButton>
          </div>
        }
      >
        {/* Custom Close Button */}
        <SwButton
          variant=""
          className="btn-close btn-close-custom"
          onClick={handleCloseBooking}
          disabled={isSubmitting}
        />

        <h3 className="SwModalSubHeading">Alert!!</h3>
        <p className="mb-1">
          Are you sure you want to confirm the room booking?
        </p>
      </SwModal>
    </>
  );
}

export default connect()(CreateRoomBooking);
